import { Breadcrumb, Card, Col, Empty, message, Row, Select, Space, Spin, Tooltip } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Title from 'antd/es/typography/Title';
import React, { useEffect, useReducer} from 'react';
import Plot from 'react-plotly.js';
import { AreaChartOutlined, HomeOutlined } from '@ant-design/icons';

import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context';
import vspSurveyReducer from './reducer';
import { VSP_INVERSION_PLOT, VSP_INVERSION_PLOT_ERROR, VSP_INVERSION_PLOT_SUCCESS } from './constants';
import axios from 'axios';


const VSPSurveyInversionGraph = () => {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const { state } = useLocation();
	const navigate = useNavigate();
	const {wellFieldinfo, getWellFieldsInfo, surveySeriesinfo, getSurveySeriesInfo} = useAuth();
	const initalState = {plotInversionData: [], loading: false, error: false, updateData : {} };
	const [data, dispatch] = useReducer(vspSurveyReducer, initalState);	
	
	
	useEffect(() => {
		getWellFieldsInfo(authtoken);
		getSurveySeriesInfo(authtoken, null);
		loadInversionData(state && state.data && state.data.id ? state.data.id : null );

	},[authtoken]);
	
	const wellFields = [];
	wellFieldinfo && wellFieldinfo.map((item) => {
		wellFields.push({
			value : item.id,
			label : item.name.toUpperCase(),
			distanceFrom: item.distanceFrom,
			distanceTo: item.distanceTo,
			depthFrom: item.depthFrom,
			depthTo: item.depthTo

		});

	});

	const suveySeriesData = [];
	surveySeriesinfo && surveySeriesinfo.map((item) => {
		suveySeriesData.push({
			value : item.id,
			label : item.name.toUpperCase()
		});
		
	});
	
	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());


	const loadInversionData =(id)=>{

		if(id){
				
			dispatch({ type : VSP_INVERSION_PLOT });
			let config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: `${api}/inversion-data?inversionIds=${JSON.stringify(id)}`,
				timeout: timeout,
				headers: { 
					Authorization:`Bearer ${authtoken}`
				}
			};
								
			axios.request(config)
				.then((response) => {
					if(response.status == 200) {	
																	
						dispatch({ type : VSP_INVERSION_PLOT_SUCCESS, payload : response });
					} 
					else {
						dispatch({ type : VSP_INVERSION_PLOT_ERROR });
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : VSP_INVERSION_PLOT_ERROR });
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}else{
			let response ={data:[]};
			dispatch({ type : VSP_INVERSION_PLOT_SUCCESS, payload : response });
		}

	};	

	const plotdata = [
		{
			z: data && data.plotInversionData && data.plotInversionData[0] && data.plotInversionData[0].amplitude ? data.plotInversionData[0].amplitude : [],
			x: data && data.plotInversionData && data.plotInversionData[0] && data.plotInversionData[0].crosslines ? data.plotInversionData[0].crosslines : [],
			y: data && data.plotInversionData && data.plotInversionData[0] && data.plotInversionData[0].times ? data.plotInversionData[0].times : [],
			type: 'heatmap',
			zsmooth: 'best',
			colorscale: 'RdBu',
			reversescale: true,
			colorbar: {thickness: 10,
				// thicknessmode: 'pixels',
				// lenmode: 'fraction',
				outlinewidth: 0},
			hovertemplate: ` ${langdata?.Distancem ?? 'Distance (m)'} : %{x} <br> ${langdata?.Amplitude ?? 'Amplitude'} : %{z} <br> ${langdata?.Depth ?? 'Depth'} : %{y}<extra></extra>`,
		},
	];

	const layout = {
		title: {
			text: langdata?.InversionGraph || 'Inversion Graph',
			font: { size: 20, weight: 'bold' },
		},
		xaxis: {
			title: langdata?.FieldDistancem || 'Field Distance (m)',
		},
		yaxis: {
			title: langdata?.Depthm || 'Depth (m)',
			autorange: 'reversed',
		},
		margin: { t: 40, r: 40, l: 60, b: 60 },
	};	
	
	
	return (

		<Content>
			<Row style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center'
			}} >
		
				<Col span={8}>
					<Row>
						<Space>
							<AreaChartOutlined style={{fontSize:'30px'}}/>
							{/* </Col> */}
						</Space>
						<Space>&nbsp;&nbsp;</Space>
							
						{/* <Col style={{marginLeft:'4px'}} span={19}> */}
						<Title level={4} style={{ paddingTop:'10px'}}> {langdata && langdata.InversionGraph ? langdata.InversionGraph : 'Inversion Graph'}</Title>
						
					</Row>
				</Col>
				<Col span={16}>
					<Row justify="end">
						<Col>
							<Tooltip placement="bottom" title={langdata && langdata.FieldName ? langdata.FieldName : 'Field Name'}>
								<Space>
									<Select
										style={{ width: '180px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.FieldName ? langdata.FieldName : 'Field Name'}
										optionFilterProp="children"
										value={state && state.data && state.data.wellFieldId ? state.data.wellFieldId : null}
										options={wellFields}
										disabled
									/>
								</Space>
							</Tooltip>
							<Space>&nbsp;</Space>

							<Tooltip placement="bottom" title={langdata && langdata.SurveySeries ? langdata.SurveySeries : 'Survey Series'}>
								<Space>
									<Select
										style={{ width: '180px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.SurveySeries ? langdata.SurveySeries : 'Survey Series'}
										optionFilterProp="children"
										value={state && state.data && state.data.seriesId ? state.data.seriesId : null}
										options={suveySeriesData}
										disabled
									/>
								</Space>
							</Tooltip>
							<Space>&nbsp;</Space>

						</Col>
					</Row>
				</Col>
			</Row>
			<Row style={{
				margin: '10px',
				// marginTop : '5px',
				// paddingLeft: '10px',
				// paddingRight: '10px',
				// background: '#FFFFFF',
				alignItems:'center',
			}}  >
				<Col span={18}>
					<Breadcrumb
						items={[
							{
								href: '/dashboard',
								title: <HomeOutlined />,
							},
							{
								title: ( state && state?.path === 'well-visualization' ? <a onClick={()=>{navigate(-4);}}>{langdata && langdata.WellVisualization ? langdata.WellVisualization:'Well Visualization'}</a> :  <a onClick={()=>{navigate(-4);}}>{langdata && langdata.WellVisualization ? langdata.WellVisualization:'Well Visualization'}</a>)
							},
							{
								title: ( state && state?.path === 'vsp-survey' ? <a onClick={()=>{navigate(-3);}}>{langdata && langdata.VSPSurvey ? langdata.VSPSurvey:'VSP Survey'}</a> :  <a onClick={()=>{navigate(-3);}}>{langdata && langdata.VSPSurvey ? langdata.VSPSurvey:'VSP Survey'}</a>)
							},
							{
								title: ( state && state?.path === 'vsp-survey-details' ? <a onClick={()=>{navigate(-2);}}>{langdata && langdata.VSPSurveyDetails ? langdata.VSPSurveyDetails:'VSP Survey Details'}</a> :  <a onClick={()=>{navigate(-2);}}>{langdata && langdata.VSPSurveyDetails ? langdata.VSPSurveyDetails:'VSP Survey Details'}</a>)
							},
							{
								title: ( state && state?.path === 'vsp-survey-inversion' ? <a onClick={()=>{navigate(-1);}}>{langdata && langdata.Inversion ? langdata.Inversion:'Inversion'}</a> :  <a onClick={()=>{navigate(-1);}}>{langdata && langdata.Inversion ? langdata.Inversion:'Inversion'}</a>)
							},
							{
								title: `${langdata && langdata.InversionGraph ? langdata.InversionGraph : 'Inversion Graph'}`,
							},
						
						]}
						// style={{ marginBottom : '10px'}}
					/>
				</Col>
				<Col span={6} style={{ display : 'flex', justifyContent : 'flex-end'}}>
					{/* <Tooltip title={langdata && langdata.Graphlayout ? langdata.Graphlayout:'Graph layout'}>
						<Switch style={{backgroundColor: graphScroll == false ? '' : 'green'}} checkedChildren={langdata && langdata.Scroll ? langdata.Scroll:'Scroll'} unCheckedChildren={langdata && langdata.Fixed ? langdata.Fixed:'Fixed'} checked={graphScroll} onClick={handleSelectGraphScroll}/>
					</Tooltip> */}
				</Col>
			</Row>
			<Card style={{ minHeight: '500px', padding : '5px', marginLeft : '20px', marginRight : '20px'  }}>
				<Row style={{
					// margin: '10px',
					// marginBottom : '0px',
					// marginTop : '10px',
					// paddingLeft: '10px',
					// paddingRight: '10px',
					// backgroundColor: '#ffffff',
					alignItems:'center',
				}} >
					<Col span={24}>	
							
						<Col>
							{/* <Spin spinning={spin} tip={`${langdata && langdata.Loading ? langdata.Loading: 'Loading'}...`} > */}
							{plotdata && plotdata[0]?.z?.length > 0 ?
								<>
									<Plot
										data={plotdata}
										layout={layout}

										style={{ width: '100%', height: '800px' }}
										config={{
											responsive: true,
											displayModeBar: true,
											displaylogo : false,
											modeBarButtonsToRemove: [],
										}}

									// onUpdate={(figure) => {
									// 	if (
									// 		figure.layout &&
									// 		figure.layout.sliders &&
									// 		figure.layout.sliders[0] &&
									// 		typeof figure.layout.sliders[0].active === 'number'
									// 	) {
									// 		const newOffset = vspSurveyOffsetsarray[figure.layout.sliders[0].active];
									// 		if (newOffset !== fieldOffset) {
									// 			handleSetFieldOffset(newOffset); // <-- triggers dropdown logic too
									// 		}
									// 	}
									// }}
									/>
								</> :
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />

							}
								
							{/* </Spin> */}
						</Col>
					</Col>
				</Row>
			</Card> 

	
			<Spin fullscreen spinning={data.loading} />
		</Content>
		
	);
};

export default VSPSurveyInversionGraph;
